<template>
  
  <div class="center">
      <div class="center-list">
          <div :class="item == current ? 'center-list-active center-list-item' : 'center-list-item'"
              @click="switchCurrent(item)" v-for="(item, index) in navList" :key="index">{{ item }}</div>
      </div>
  </div>
  <div class="bottom">
      <div v-if="loading" class="loading">加载中...</div>
      <div v-else-if="imageList.length === 0" class="no-data">暂无图片</div>
      <div class="image-container" v-for="(image, index) in imageList" :key="index" @mouseenter="hoverIndex = index" @mouseleave="hoverIndex = -1" v-else>
          <img class="bottom-img"   :src="processImageUrl(image.image_url)" />
          <!-- <img class="bottom-img"  style="border: 1px solid red;" src="https://pic.rmb.bdstatic.com/bjh/news/3fe6db1a8d291be39192f9a06c74ce99.png" /> -->
          <div v-show="hoverIndex === index" class="image-hover-overlay">
              <div class="hover-buttons">
                  <div class="hover-button" @click="goToSameDesign(processImageUrl(image.image_url))">
                      <img src="../images/mentou.png" alt="一键同款" class="hover-icon" />
                      <span>一键同款</span>
                  </div>
                  <div class="hover-button" @click="handleDownload(index)">
                      <img src="../images/download.png" alt="下载" class="hover-icon" />
                      <span>下载</span>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <!-- 分页控件 -->
  <div class="pagination" >
    <button 
      @click="fetchImageList(currentPage - 1)" 
      :disabled="currentPage <= 1"
      class="pagination-btn"
    >
      上一页
    </button>
    <span class="pagination-info">
      第 {{ currentPage }} 页，共 {{ Math.ceil(total / 20)  }} 页
    </span>
    <button 
      @click="fetchImageList(currentPage + 1)" 
      :disabled="currentPage >= Math.ceil(total / 20) || total <= 0"
      class="pagination-btn"
    >
      下一页
    </button>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { getCategoryList, getCategoryImages } from '@/api/category';

const router = useRouter();
const store = useStore();
const navList = ref([])
const categories = ref([])
const current = ref('全部');
const hoverDesign = ref(false);
const hoverRestore = ref(false);
const hoverIndex = ref(-1);
const imageList = ref([]);
const currentPage = ref(1);
const total = ref(0);
const loading = ref(false);

// 加载分类列表
const loadCategories = async () => {
  try {
    const response = await getCategoryList();
    if (response.data.code === 10000) {
      // 存储分类数据
      categories.value = response.data.data.categories;
      // 将分类列表设置到navList，包含'全部'选项
      navList.value = ['全部', ...response.data.data.categories.map(cat => cat.name)];
      current.value = '全部'; // 默认选择全部
    }
  } catch (error) {
    console.error('加载分类列表失败:', error);
  }
};

// 获取图片列表
const fetchImageList = async (page = 1) => {
    console.log(page);
    
  loading.value = true;
  try {
    // 如果选择的是'全部'，则获取所有图片；否则获取对应分类的图片
    if (current.value === '全部') {
      // 调用getCategoryImages并传入null获取所有图片
      const response = await getCategoryImages(null);
      if (response.data.code === 10000) {
        // 模拟分页效果，实际项目中后端应提供分页接口
        const allImages = response.data.data.images || [];
        const startIndex = (page - 1) * 20;
        const endIndex = startIndex + 20;
        imageList.value = allImages.slice(startIndex, endIndex);
        total.value = allImages.length;
        currentPage.value = page;
      }
    } else {
      // 根据分类名称获取分类ID
      const category = categories.value.find(cat => cat.name === current.value);
      if (category) {
        const categoryResponse = await getCategoryImages(category.id);
        if (categoryResponse.data.code === 10000) {
          // 模拟分页效果，实际项目中后端应提供分页接口
          const allImages = categoryResponse.data.data.images || [];
          const startIndex = (page - 1) * 20;
          const endIndex = startIndex + 20;
          imageList.value = allImages.slice(startIndex, endIndex);
          total.value = allImages.length;
          currentPage.value = page;
        }
      }
    }
  } catch (error) {
    console.error('获取图片列表失败:', error);
  } finally {
    loading.value = false;
  }
};

const switchCurrent = (e) => {
    current.value = e;
    // 切换分类时获取对应分类的图片
    fetchImageList(1); // 重置为第一页
}

// 组件挂载时获取分类列表和图片列表
onMounted(async () => {
  await loadCategories();
  fetchImageList();
});

// 处理图片URL，使其通过代理访问
const processImageUrl = (filepath) => {
    if (!filepath) return '';
    // 如果是完整URL，直接返回
    if (filepath.startsWith('http')) {
        return filepath;
    }
    // 如果是相对路径，添加代理前缀
    if (filepath.startsWith('/')) {
        return filepath;
    }
    // 其他情况，添加/uploads前缀
    return '/uploads/' + filepath;
};

// 跳转到一键同款页面
const goToSameDesign = (imageUrl) => {
    // 将图片URL作为查询参数传递
    router.push({
        path: '/same-design',
        query: { imageUrl: imageUrl }
    });
}

// 处理下载
const handleDownload = (index) => {
    const image = imageList.value[index];
    if (!image) return;
    
    const imageUrl = processImageUrl(image.image_url);
    const fileName = getFileNameFromPath(image.image_url) || 'image.jpg';
    
    downloadImage(imageUrl, fileName);
}

// 从路径中提取文件名
const getFileNameFromPath = (filepath) => {
    if (!filepath) return null;
    
    // 如果是URL，获取最后的文件名部分
    const url = new URL(filepath, window.location.origin);
    const pathname = url.pathname;
    const filename = pathname.split('/').pop();
    
    if (filename && filename.includes('.')) {
        return filename;
    }
    
    return null;
}

// 下载图片
const downloadImage = (url, filename) => {
    // 创建一个隐藏的下载链接
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    
    // 添加到DOM，点击，然后移除
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

// 跳转到一键设计门头页面
const goToDesign = () => {
    router.push('/design');
}

// 跳转到现场还原页面
const goToRestore = () => {
    router.push('/restore');
}
</script>

<style scoped lang="less">
.top {
    display: flex;
    align-items: center;
    gap: 16px;
    cursor: pointer;
}

.top-item1 {
    box-sizing: border-box;
    width: auto;
    height: 149px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 16px 16px 16px 16px;
    display: flex;
    align-items: center;

    &-image {
        width: 100%;
        height: 100%;
    }
}

.top-item {
    box-sizing: border-box;
    padding: 26px 30px;
    width: 18vw;
    height: 144px;
    background: #292929;
    border-radius: 16px 16px 16px 16px;
    display: flex;
    align-items: center;
    position: relative;
    overflow: hidden;

    &-left {
        width: 170px;
        position: relative;
        z-index: 1;

        &-title {
            font-family: Microsoft YaHei UI, Microsoft YaHei UI;
            font-weight: bold;
            font-size: 20px;
            color: #FFFFFF;
        }

        &-brief {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #FFFFFF;
            margin-top: 10px;
        }
    }

    &-btn {
        width: 98px;
        height: 36px;
        background: #5EFF00;
        border-radius: 40px 40px 40px 40px;
        border: none;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
        cursor: pointer;
        margin-left: 10px;
        position: relative;
        z-index: 1;
    }
}

.center {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-search {
        cursor: pointer;
        display: flex;
        align-items: center;
        width: 338px;
        height: 36px;

        &-input {
            width: 287px;
            height: 36px;
            border-radius: 6px 0px 0px 6px;
            border: 1px solid #2B2C2C;
            background: none;
            padding: 8px 16px;
            box-sizing: border-box;
        }

        &-icon {
            width: 52px;
            height: 36px;
            background: #212121;
            border-radius: 0px 6px 6px 0px;
            border: 1px solid #212121;
            display: flex;
            align-items: center;
            justify-content: center;

            &-image {
                width: 14px;
                height: 14px;
                border-radius: 0px 0px 0px 0px;
            }
        }
    }

    &-list {
        display: flex;
        align-items: center;

        &-item {
            margin-left: 8px;
            width: 60px;
            height: 36px;
            background: #2B2C2C;
            border-radius: 6px 6px 6px 6px;
            border: 1px solid #2B2C2C;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }

        &-active {
            background: #5EFF00;
            border-radius: 6px 6px 6px 6px;
            border: 1px solid #5EFF00;
        }

        &-item:first-child {
            margin-left: 0;
        }
    }
}

.bottom {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    margin-top: 24px;
    overflow-y: auto;
    height: 60vh;
    max-height: 70vh;
    &-img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

/* 加载和暂无数据样式 */
.loading, .no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
  font-size: 18px;
  color: #999;
}

/* 图片容器 */
.image-container {
    position: relative;
    width: 100%;
    height: 180px;
}

/* 图片hover覆盖层 */
.image-hover-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    padding: 10px;
    transform: translateY(100%);
    transition: transform 0.3s ease;
}

.image-container:hover .image-hover-overlay {
    transform: translateY(0);
}

/* hover按钮容器 */
.hover-buttons {
    display: flex;
    justify-content: space-between;
}

/* hover按钮 */
.hover-button {
    display: flex;
    align-items: center;
    color: white;
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 4px;
    transition: background-color 0.3s;
}

.hover-button:hover {
    background-color: #5EFF00;
    color: #000;
}

/* hover图标 */
.hover-icon {
    width: 16px;
    height: 16px;
    margin-right: 5px;
}

/* Hover效果样式 */
.hover-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    z-index: 0;
}

.hover-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.7;
    transition: opacity 0.3s ease;
}

/* 响应式适配 */
@media screen and (min-width: 1201px) {
    .bottom {
        grid-template-columns: repeat(5, 1fr);
    }
}

@media screen and (max-width: 1200px) {
    .top {
        flex-wrap: wrap;
    }
    
    .top-item {
        margin-bottom: 16px;
    }
    
    .top-item1 {
        width: 100%;
        max-width: 639px;
    }
}

@media screen and (max-width: 768px) {
    .top {
        flex-direction: column;
        align-items: center;
    }
    
    .top-item {
        width: 100%;
        max-width: 400px;
    }
    
    .center {
        flex-direction: column;
        align-items: stretch;
    }
    
    .center-search {
        margin-top: 16px;
        width: 100%;
        max-width: 400px;
    }
    
    .center-search-input {
        width: calc(100% - 52px);
    }
    
    .bottom {
        grid-template-columns: repeat(2, 1fr);
        height: 60vh;
        max-height: 60vh;
    }
    
    .image-container {
        height: 150px;
    }
}

@media screen and (max-width: 480px) {
    .top-item {
        max-width: 100%;
    }
    
    .center-list {
        margin-bottom: 16px;
        justify-content: center;
    }
    
    .center-list-item {
        width: auto;
        min-width: 50px;
        padding: 0 10px;
        font-size: 14px;
    }
    
    .bottom {
        grid-template-columns: 1fr;
        height: 70vh;
        max-height: 70vh;
    }
    
    .image-container {
        height: 200px;
    }
    
    .hover-buttons {
        flex-direction: column;
        gap: 5px;
    }
    
    .hover-button {
        justify-content: center;
        padding: 8px;
    }
}

/* 分页控件样式 */
.pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    gap: 20px;
}

.pagination-btn {
    padding: 8px 16px;
    background: #292929;
    border: 1px solid #2B2C2C;
    border-radius: 4px;
    color: white;
    cursor: pointer;
    transition: all 0.3s;
}

.pagination-btn:hover:not(:disabled) {
    background: #3a3a3a;
}

.pagination-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.pagination-info {
    color: #aaa;
    font-size: 14px;
}

/* 垂直滚动条 */
::-webkit-scrollbar {
    width: 12px;
    /* 垂直滚动条宽度 */
    height: 12px;
    /* 水平滚动条高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
    background: #090909;
    border-radius: 6px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #121212, #939292);
    border-radius: 6px;
}

/* 滑块悬停效果 */
::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #666, #444);
}

/* 水平滚动条滑块 */
::-webkit-scrollbar-thumb:horizontal {
    background: linear-gradient(90deg, #000000, #000000);
}

/* 角落 */
::-webkit-scrollbar-corner {
    background: #000000;
}
</style>